import { call, takeEvery, all, put } from "redux-saga/effects";
import { storeFetchedSegmapList, storeFetchedCompanyList, storeFetchedCostCategory, storeFetchedCostCenter } from "./actions";
import { handlError, parseError } from "../../app/serverError";
import { URL, getHeaderJWT } from "../../../store/path";
import { merge } from "lodash";

import * as type from "./types";
import userACL from "../../../store/access";
import axios from "axios";

function* fetchSegmapList() {
  yield takeEvery(type.FETCH_SEGMAP_LIST, requestSegmap);
}

function* fetchCostCategory() {
  yield takeEvery(type.FETCH_COST_CATEGORY, requestCostCategory);
}

function* fetchCostCenter() {
  yield takeEvery(type.FETCH_COST_CENTER, requestCostCenter);
}

function* requestSegmap() {
  const { response, error } = yield call(requestSegmapAPI);
  if (response && response.data) {
    const resData = response.data;

    // Handle new response format: { company: [], segments: [] }
    const companyArr = Array.isArray(resData.company) ? resData.company : [];
    const segmentsArr = Array.isArray(resData.segments) ? resData.segments : [];

    const modifiedCompany = companyArr.map((item) => ({
      key: item.id,
      value: item.id,
      text: item.name,
    }));

    const modifiedSegments = segmentsArr.map((item) => ({
      ...item,
      key: item.segid,
      value: item.segid,
      text: item.name,
    }));

    yield put(storeFetchedCompanyList(modifiedCompany));
    yield put(storeFetchedSegmapList(modifiedSegments));
  } else {
    yield put({ type: type.FETCH_SEGMAP_LIST_FAILURE });
    yield put(handlError(requestSegmap, error ? parseError(error) : { message: 'Unknown error occurred' }));
    sagaErrorMessage(error, requestSegmap);
  }
}

function* requestCostCategory() {
  const { response, error } = yield call(requestCostCategoryAPI);
  if (response && response.data && response.data.data && Array.isArray(response.data.data)) {
    const modifiedData = response.data.data.map((item) => {
      const normalized = typeof item.name === 'string' ? item.name.trim().toLowerCase() : item.name;
      return {
        ...item,
        key: normalized,
        value: normalized,
        text: item.name,
      };
    });
    yield put(storeFetchedCostCategory(modifiedData));
  } else {
    yield put({ type: type.FETCH_COST_CATEGORY_FAILURE });
    yield put(handlError(requestCostCategory, error ? parseError(error) : { message: 'Unknown error occurred' }));
    sagaErrorMessage(error, requestCostCategory);
  }
}

function* requestCostCenter() {
  const { response, error } = yield call(requestCostCenterAPI);
  if (response && response.data && response.data.data && Array.isArray(response.data.data)) {
    const modifiedData = response.data.data.map((item) => {
      const normalized = typeof item.name === 'string' ? item.name.trim().toLowerCase() : item.name;
      return {
        ...item,
        key: normalized,
        value: normalized,
        text: item.name,
      };
    });
    yield put(storeFetchedCostCenter(modifiedData));
  } else {
    yield put({ type: type.FETCH_COST_CENTER_FAILURE });
    yield put(handlError(requestCostCenter, error ? parseError(error) : { message: 'Unknown error occurred' }));
    sagaErrorMessage(error, requestCostCenter);
  }
}

async function requestSegmapAPI(data) {
  try {
    data = merge({}, data, userACL.atFetch());
    const response = await axios.post(
      URL + "/master/rlb/segdetails",
      data,
      getHeaderJWT(),
      {
        crossDomain: true,
      }
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

async function requestCostCategoryAPI() {
  try {
    let data = merge({}, userACL.atFetch());
    const response = await axios.post(
      URL + "/master/rlb/costCatagory",
      data,
      getHeaderJWT(),
      {
        crossDomain: true,
      }
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

async function requestCostCenterAPI() {
  try {
    let data = merge({}, userACL.atFetch());
    const response = await axios.post(
      URL + "/master/rlb/costCenter",
      data,
      getHeaderJWT(),
      {
        crossDomain: true,
      }
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type);
  console.log(error);
  console.groupEnd();
};

export default function* commonSaga() {
  yield all([
    fetchSegmapList(),
    fetchCostCategory(),
    fetchCostCenter()
  ]);
}
